export default __webpack_public_path__ + "static/media/bellon.753c343e.svg";